import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { EPF } from 'src/model/epf.model';
import { Loan } from 'src/model/loan.model';
import { EpfService } from 'src/services/epf.service';

@Component({
    selector: 'app-mark-legacy-epfs',
    templateUrl: './mark-legacy-epfs.component.html',
    styleUrls: ['./mark-legacy-epfs.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class MarkLegacyEpfsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private epfService = inject(EpfService);

  @Input() epfDetails: EPF;
  @Input() loanList: Loan[] = [];
  @Input() selectedCustomer: Customer;
  @Input() selectedProfileId: number;

  displayedColumns: string[];
  dataSource = new MatTableDataSource;
  disabledSubmit = false;
  checkedAll = false;

  epfDate: Date;
  epfAmount: number;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {
    this.displayedColumns = ['Check', 'DateCreated', 'ReceiptNumber', 'LoanCode', 'Principal', 'Scheme', 'MonthlyPayment'];

    if (this.loanList != undefined) {
      this.dataSource = new MatTableDataSource<Loan>(this.loanList);
      this.dataSource.sort = this.sort;
    }

    this.epfDetails ||= new EPF(undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    this.epfDate = this.epfDetails.Date;
    this.epfAmount = this.epfDetails.Amount;
  }

  checkIsNull() {
    let error = "";

    if (this.epfDate == undefined)
      error += "- EPF Date\n";

    if (this.epfAmount == undefined || this.epfAmount == 0)
      error += "- EPF Amount\n";
    if (this.loanList.filter(x => x.IsSelected).length == 0)
      error += "- Select loan to mark as EPF"

    if (error != "")
      error = "Please fill in correctly:\n" + error;
    return error;
  }

  calculateSelected() {
    let sum = 0;

    for (let i = 0; i < this.loanList.length; i++) {
      if (this.loanList[i].IsSelected == true)
        sum++
    }

    return sum
  }

  async submit() {
    const error = this.checkIsNull();
    if (error != "")
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER);
    else {
      if (this.epfDetails.Date == undefined) {
        await this.updateEPFDetails();
      }
      this.markAsEPFLoan();
    }
  }

  async updateEPFDetails() {
    const epf: EPF = new EPF();
    epf.Date = this.epfDate;
    epf.Amount = this.epfAmount;

    this.disabledSubmit = true;
    try {
      (this.epfDetails == undefined || this.epfDetails.Date == undefined)
        ? await this.epfService.postCustomerEPF(this.selectedCustomer.ID, epf)
        : await this.epfService.updateCustomerEPF(this.selectedCustomer.ID, epf);
    } finally {
      this.disabledSubmit = false;
    }
  }

  markAsEPFLoan() {
    this.disabledSubmit = true;

    const data = this.loanList.filter(x => x.IsSelected).map(x => x.ID);

    const xhr = this.restApi.putRequest(this.constructApi.getMarkLegacyEPF(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //if success , then proceed
        if (xhr.status == 200) {
          window.location.reload();
        }
        else {
          this.disabledSubmit = false;
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  isCheckedAll() {
    return this.loanList.length === this.loanList.filter(x => x.IsSelected).length;
  }

  checkAll() {
    this.loanList.map(x => x.IsSelected = this.checkedAll);
  }

  reset() {
    this.activeModal.close();
  }
}
